import { render } from "./About.vue?vue&type=template&id=4c5ce5c0"
const script = {}
script.render = render

export default script